export default __webpack_public_path__ + "static/blob14-f36012a75acbfe4ccda7daa04f0d6a44.svg";